import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectUser } from '../store/slices/authSlice';

/**
 * Component to protect routes based on user roles
 * Redirects to unauthorized page if user doesn't have required permissions
 */
const RoleProtectedRoute = ({ children, checkPermission }) => {
  const user = useSelector(selectUser);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user has permission
    if (!checkPermission(user)) {
      navigate('/admin/unauthorized', { replace: true });
    }
  }, [user, checkPermission, navigate]);

  // If user doesn't have permission, don't render children
  if (!checkPermission(user)) {
    return null;
  }

  return children;
};

export default RoleProtectedRoute;
